// import { CustomValidators } from './../../validators/custom.validator';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController, ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage';

import { UsersFirebaseService } from '../services/firebase/users-firebase.service';
import { User } from '../shared/types/user.types';
import { AuthProvider } from './../../providers/auth';

@Component({
  selector: 'app-user',
  templateUrl: './user.page.html',
  styleUrls: ['./user.page.scss'],
})
export class UserPage implements OnInit {
  @Input() atualizarDados = false;

  user: User = {
    email: '',
    name: '',
    pontos_fidelidade: 0,
    tel: '',
    uid: '',
    roles: [],
  };

  form: FormGroup;

  constructor(
    private authProvider: AuthProvider,
    private formBuilder: FormBuilder,
    private modalCtrl: ModalController,
    private storage: Storage,
    private toasCtrl: ToastController,
    private usersService: UsersFirebaseService,
  ) { }

  ngOnInit() {

    this.form = this.formBuilder.group({
      user: this.formBuilder.group({
        email: ['', Validators.email],
        name: ['', [Validators.required, Validators.minLength(2)]],
        tel: ['(13) ',
          [
            Validators.maxLength(15),
            // CustomValidators.validateTelefone
            Validators.pattern(/^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$/)
          ]
        ],
      }),
      reset: [false],
      resetPassword: this.formBuilder.group({
        newpassword: ['', Validators.required],
      })
    });
    this.form.get('resetPassword').disable();


    this.form.get('reset').valueChanges.subscribe(reset => {
      reset
        ? this.form.get('resetPassword').enable()
        : this.form.get('resetPassword').disable();
    });

    this.init();
  }

  async init() {
    const user = await this.storage.get('user');

    // tslint:disable-next-line: no-string-literal
    if (user && user['uid']) {
      this.user = await this.usersService.getUser(user['uid']);

      const name = this.user.name === "Sem Nome" ? '' : this.user.name;
      this.form.get('user').patchValue({
        ...this.user,
        name
      });
    }
  }

  async closeModal(role: string = 'closed') {
    await this.modalCtrl.dismiss(null, role);
  }

  async onSubmit() {

    if (!this.form.get('reset').value) {
      this.form.get('resetPassword').disable();
    }

    const form = this.form.value;
    this.authProvider.updateCurrentUser(form);
    this.form.get('resetPassword').enable();

    const user = await this.storage.get('user');
    this.storage.set('user', {...user, ...form.user});
    this.usersService.updateUser(user.uid, form.user);

    const toast = await this.toasCtrl.create({
      message: 'Usuário alterado com sucesso',
      duration: 2000
    });
    toast.present();
    this.closeModal('atualizado');

  }

}
